const state = {
    pwaPromptInstall: null,
    isPWA: null
}

export default state